import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { ShieldCheck, Phone, Mail, FileText, ScanFace, CheckCircle2 } from "lucide-react";
import { Spinner, StatusBadge } from "../components/common";
import { Input } from "../components/ui/input";
import api, { apiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function Verification() {
  const { user, refresh } = useAuth();
  const [v, setV] = useState(null);
  const [loading, setLoading] = useState(true);
  const [phone, setPhone] = useState(user.phone || "");
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get("/verification").then((r) => setV(r.data)).finally(() => setLoading(false)); }, []);

  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/verification/submit", {
        phone, document_url: "https://example.com/id-doc.jpg", selfie_url: "https://example.com/selfie.jpg",
      });
      toast.success("Verifikasi dikirim untuk ditinjau admin");
      const { data } = await api.get("/verification"); setV(data); refresh();
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  if (loading) return <Spinner />;
  const status = user.verified_status;
  const steps = [
    { icon: Phone, label: "Phone verification" },
    { icon: Mail, label: "Email verification" },
    { icon: FileText, label: "Identity document" },
    { icon: ScanFace, label: "Selfie / liveness" },
    { icon: ShieldCheck, label: "Admin review" },
  ];

  return (
    <div className="max-w-lg space-y-5">
      <h1 className="font-heading font-extrabold text-2xl text-navy flex items-center gap-2"><ShieldCheck className="text-sky" /> Identity Verification</h1>

      <div className="bg-white rounded-3xl p-5 shadow-soft border border-black/5 flex items-center justify-between">
        <span className="font-semibold text-navy">Status</span>
        <StatusBadge status={status === "not_verified" ? "pending" : status} />
      </div>

      <div className="bg-white rounded-3xl p-5 shadow-soft border border-black/5 space-y-3">
        {steps.map((s, i) => { const Icon = s.icon; const done = status === "verified" || (status === "pending" && i < 4); return (
          <div key={i} className="flex items-center gap-3">
            <div className={`w-9 h-9 rounded-full flex items-center justify-center ${done ? "bg-lime text-navy" : "bg-cloud text-muted-foreground"}`}>{done ? <CheckCircle2 size={16} /> : <Icon size={16} />}</div>
            <span className="text-sm font-medium text-ink">{s.label}</span>
          </div>
        ); })}
      </div>

      {status !== "verified" && (
        <div className="bg-white rounded-3xl p-5 shadow-soft border border-black/5 space-y-3">
          <div><label className="text-sm font-semibold text-ink">Nomor HP</label><Input data-testid="verify-phone" value={phone} onChange={(e) => setPhone(e.target.value)} className="rounded-xl mt-1" placeholder="+62..." /></div>
          <p className="text-xs text-muted-foreground">Untuk demo, dokumen & selfie akan diisi otomatis. Admin akan meninjau.</p>
          <button onClick={submit} disabled={busy || status === "pending"} data-testid="submit-verification"
            className="w-full rounded-full bg-lime hover:bg-lime-dark text-navy font-bold py-3 transition-colors disabled:opacity-60">
            {status === "pending" ? "Menunggu review admin..." : "Submit for Verification"}
          </button>
        </div>
      )}
      {status === "verified" && <div className="bg-lime-light/50 rounded-3xl p-5 text-center font-bold text-navy flex items-center justify-center gap-2"><ShieldCheck /> Verified BAWAINER ✓</div>}
    </div>
  );
}
